import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { getInspectionOrganizations, InspectionOrganizationDTO } from 'services/inspections-service'

interface InspectorSelectorProps {
  selectedOrganization: InspectionOrganizationDTO | null
  onOrganizationChange: (organization: InspectionOrganizationDTO | null) => void
  isConfirmed: boolean
  onConfirmationChange: (confirmed: boolean) => void
  disabled?: boolean
}

const InspectorSelector: React.FC<InspectorSelectorProps> = ({
  selectedOrganization,
  onOrganizationChange,
  isConfirmed,
  onConfirmationChange,
  disabled = false
}) => {
  const { t } = useTranslation()

  // Fetch inspection organizations
  const { data: organizations, isLoading: organizationsLoading } = useQuery(
    'inspection-organizations',
    getInspectionOrganizations
  )

  console.log(organizations)
  const handleOrganizationChange = (organizationId: string) => {
    const organization = organizations?.find(org => org.id === organizationId) || null
    onOrganizationChange(organization)
  }

  if (organizationsLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={2}>
        <CircularProgress size={24} />
        <Typography variant="body2" sx={{ ml: 1 }}>
          {t('Loading organizations...')}
        </Typography>
      </Box>
    )
  }

  if (!organizations || organizations.length === 0) {
    return (
      <Box p={2}>
        <Typography variant="body2" color="text.secondary">
          {t('No inspection organizations available')}
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 , width: '100%'}}>
      {/* Organization Selector */}
      <FormControl fullWidth disabled={disabled}>
        <InputLabel>{t('LABORATORY_ASSIGN_SELECTOR_PLACEHOLDER')}</InputLabel>
        <Select
          value={selectedOrganization?.id || ''}
          onChange={(e) => handleOrganizationChange(e.target.value)}
          label={t('LABORATORY_ASSIGN_SELECTOR_PLACEHOLDER')}
        >
          {organizations.map((org: InspectionOrganizationDTO) => (
            <MenuItem key={org.id} value={org.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {org.image_url && (
                  <img 
                    src={org.image_url} 
                    alt={org.company_name}
                    style={{ width: 24, height: 24, borderRadius: '4px', objectFit: 'cover' }}
                  />
                )}
                <Typography variant="body1">{org.company_name}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Confirmation Checkbox */}
      <FormControlLabel
        control={
          <Checkbox
            checked={isConfirmed}
            onChange={(e) => onConfirmationChange(e.target.checked)}
            disabled={disabled}
          />
        }
        label={
          <Typography variant="body2">
            {t('INSPECTOR_SELECTOR_CONFIRM_ASSIGNMENT')}
          </Typography>
        }
      />
    </Box>
  )
}

export default InspectorSelector